import React, { Component } from 'react'
import { extend } from '../../../../utils/classes'
import Credits from '../Credits'

export class Links extends Component {
  baseClass = extend(this.props.parentClass, 'links')

  links = ['About', 'FAQs', 'Contact', 'Terms of Service', 'Privacy']

  renderLinks = () =>
    this.links.map((link, index) => (
      <button key={index} className={extend(this.baseClass, 'link')}>
        {link}
      </button>
    ))

  render() {
    return (
      <div className={this.baseClass}>
        {this.renderLinks()}
        <Credits parentClass={this.baseClass} />
      </div>
    )
  }
}

export default Links
